export const BUSINESS_FIELDS_TRANS_PATH = 'EDIT_COMPANY_LINK_FORM.BUSINESS_FIELDS';
export const BUSINESS_FIELDS_GRID_COL_SPAN = 6;
